exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".IndexPage-HeroBg{background:url(" + require("./cubes.png") + "),#fafaff linear-gradient(139deg,#fafaff 45%,#effaff);background-size:40px,100%;border-bottom:1px solid #eaeaea}.IndexPage-Hero{font-family:futura-pt;font-weight:700;display:flex;flex-direction:column;margin-top:50px;margin-bottom:70px;text-align:center}.IndexPage-Hero img{vertical-align:text-bottom;margin-bottom:0;margin-left:7px;margin-right:-15px;height:92px}.IndexPage-Hero h1,.IndexPage-Hero h2,.IndexPage-Hero h3,.IndexPage-Hero h4{margin:0;font-family:inherit;font-weight:400;font-size:60px;letter-spacing:0}.HeroSlide--bold h1,.HeroSlide--bold h2,.HeroSlide--bold h3,.HeroSlide--bold h4{font-weight:700}.IndexPage-Hero h2{font-size:50px;line-height:60px;color:#000;margin-top:.3em}.IndexPage-Hero h4{font-size:30px;margin-top:.5em;line-height:1.3em;text-transform:none;color:#000}@media (max-height:640px){.IndexPage-Hero h2{font-size:48px}.IndexPage-Hero h4{font-size:26px}.IndexPage-Hero img{height:auto}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./src/components/HeroSlide.css
// module id = ./src/components/HeroSlide.css
// module chunks = 2345137460201621000 13254968351354405000 17463659626562118000